import Vue from 'vue';
import {httpService} from "@/services/http.service";
import {deviceModule} from "@/store/modules/device.module";
import {Component, Prop, Emit} from 'vue-property-decorator';

@Component
export default class EgymAuthDialogComponent extends Vue
{

  @Prop({type: Boolean, default: false}) show!: boolean;

  public formData: any = {
    client_id: '',
    client_secret: '',
    valid: true
  };

  mounted() {
    if (deviceModule.deviceConfig.egymClientId) {
      this.formData.client_id = deviceModule.deviceConfig.egymClientId
    }
    if (deviceModule.deviceConfig.egymClientSecret) {
      this.formData.client_secret = deviceModule.deviceConfig.egymClientSecret
    }
  }

  async auth()
  {
    const {client_id, client_secret} = this.formData
    try {
      await httpService.egymCredentials(client_id, client_secret);
      this.formData.valid = true
      this.close()
    } catch (e) {
      this.formData.valid = false
    }
  }

  @Emit("close")
  close()
  {
    return this.formData
  }
}